// assets
export const logo = 'https://firebasestorage.googleapis.com/v0/b/builds360.appspot.com/o/appAssets%2FLogoDefaultProject.svg?alt=media&token=a4ed1935-7432-461c-a0c9-b0015683a42c'
export const fullLogolight = 'https://firebasestorage.googleapis.com/v0/b/builds360.appspot.com/o/appAssets%2FLogoWhiteBackground.svg?alt=media&token=6425eec2-7561-47ff-807d-06ea071e606b'
export const fullLogoDark = 'https://firebasestorage.googleapis.com/v0/b/builds360.appspot.com/o/appAssets%2FLogoBackBackground.svg?alt=media&token=6e144f73-eceb-4865-bd0a-ae023129ec6c'
export const companyCodeDarkImage = 'https://firebasestorage.googleapis.com/v0/b/builds360.appspot.com/o/appAssets%2FdarkModeImage.webp?alt=media&token=a02cc4b6-8d0c-4c12-a370-dc328912b9ce'
export const companyCodeLightImage = 'https://firebasestorage.googleapis.com/v0/b/builds360.appspot.com/o/appAssets%2FlightModeImage.webp?alt=media&token=c5988019-0ebc-460b-b442-c59e795e79ef'
export const sampleCSVFile = 'https://firebasestorage.googleapis.com/v0/b/realtor-rewards-staging.firebasestorage.app/o/CSVSample%2FExampleCSV-File.csv?alt=media&token=ee73b1d1-a45b-4ddd-a949-fef38d89320e'

// default folder ID
export const defaultRootFolder = 'BuildsRoot_0'

// page URLs
export const loginPage = '/Login'
export const resetPasswordURL = '/resetPassword'
export const createAccountPage = '/createAccount/:companyCode?'
export const createCompanyPage = '/createCompanyAccount'
export const accountActivation = '/activate'
export const profilePage = '/profile'
export const projectsURL = '/projects'
export const projectDetailURL = '/projects/:projectID'
export const quickUploadParam = 'quickUpload'
export const tagsURL = '/tags'
export const manageUsersPage = '/manageUsers'
export const autoNotificationsURL = '/autoNotifications'
export const notificationsURL = '/notifications'
export const notificationURL = '/notifications/:id'
export const notificationCampaignsURL = '/campaigns'
export const completeProfileURL = '/completeProfile'
export const adminSettingsURL = '/adminSettings'
export const ReportsPageURL = '/reports'
export const analyticsPageURL = '/analytics'
export const myDashboardURL = '/myDashboard'
export const timelinePage = '/timeline/:companyId/:projectId'
export const downloadPage = '/download/:companyId/:projectId'
export const notAuthorized = '/notAuthorized'
export const notFound404 = '/notFound404'
export const testPage = '/test'

export const footerHeight = 70
export const drawerWidth = 240

export const toolTipTimeButton = 300
export const toolTipTimeTable = 300
export const toolTipSidebar = 600
export const toastHideduration = 6000

// builder-side embed snippets
export const BUILDER_SIDE_TIMELINE_SCRIPT = `<div id='BuildsProjectContainer'></div><script defer src='https://builds360.com/assets/builds360ClientScript.v2.min.js' data-container-id='BuildsProjectContainer' data-endpoint='https://builds360.com/embed/clientRetrieveProjectEmbedREST'></script>`
export const BUILDER_SIDE_SHOWCASE_SCRIPT = `<div id='BuildsShowcaseContainer'></div><script defer src='https://builds360.com/assets/builds360ShowcaseScript.v1.min.js' data-container-id='BuildsShowcaseContainer' data-endpoint='https://builds360.com/embed/clientRetrieveShowcaseProjectsREST' data-page-size='12'></script>`
